<template>
    <div class="c-a-input c-a-input--search">
        <label v-if="label" class="c-a-input__label" :for="name">{{label}}</label>
        <div class="c-a-input__wrapper c-a-input__wrapper--with-icon-left c-a-input__wrapper--with-button">
            <icon
                class="c-a-input__icon"
                :icon="'search'"></icon>
            <input
                type="search"
                :id="name"
                :name="name"
                :placeholder="placeholder"
                class="c-a-input__input"
                :value="value"
                @input="updated"
                @keyup.enter="searchFunction"
            />
            <button-atom
                :label="'Sök'"
                @buttonClicked="searchFunction"></button-atom>
        </div>
    </div>
</template>

<script>
    import ButtonAtom from '../AtomButton.vue';
    import Icon from '../AtomIcon.vue'

    export default {
        props: [
            'name',
            'label',
            'value',
            'searchFunction',
            'placeholder',
        ],
        components: {
            ButtonAtom,
            Icon
        },
        methods: {
            updated(event){
                this.$emit('input', event.target.value);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomInputSearch.vue